module.exports = __webpack_public_path__ + "static/media/GY.140983e9.svg";